import * as yup from 'yup'
import cpfValidator from '../../../utils/cpfValidator'
import { phoneValidate } from '../../../utils/phoneValidate'
import { messageHelper } from '../../../utils/messageHelper'

export const customerSchema = yup.object({
  email: yup
    .string()
    .email('Insira um email válido')
    .required('Email é obrigatório'),
  name: yup
    .string()
    .required('Nome é obrigatório')
    .test(
      'name min size validation',
      messageHelper.yup.creator.error.shortName,
      (value) => {
        return !(value && value!.trim().length < 3)
      }
    ),
  lastName: yup
    .string()
    .required('Sobrenome é obrigatório')
    .test(
      'name min size validation',
      messageHelper.yup.creator.error.shortLastName,
      (value) => {
        return !(value && value!.trim().length < 3)
      }
    ),
  city: yup.string().required('Cidade é obrigatório'),
  state: yup.string().required('Estado é obrigatório'),
  street: yup.string().required('Endereço é obrigatório'),
  district: yup.string().required('Bairro é obrigatório'),
  complement: yup.string().optional(),
  number: yup.string()
    .required('Número é obrigatório')
    .test('numberVerify', 'Número não pode ser 0', (values) => {
      if (values && values === '0') {
        return false
      } else return true
    }),
  zipCode: yup
    .string()
    .required('CEP é obrigatório')
    .matches(/^\d{5}-\d{3}$/, 'CEP inválido'),
  gender: yup
    .string()
    .required('Gênero é obrigatório')
    .oneOf(['MASCULINO', 'FEMININO', 'OUTRO', 'PREFIRO_NAO_FALAR'], 'Gênero inválido'),
birthDate: yup
  .string()
  .required('Data de nascimento é obrigatória')
  .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Data inválida')
  .test('birthDate', 'Data de nascimento inválida', (value) => {
    if (!value) return false

    const [dayStr, monthStr, yearStr] = value.split('/')
    const day = Number(dayStr)
    const month = Number(monthStr)
    const year = Number(yearStr)

    if (
      isNaN(day) ||
      isNaN(month) ||
      isNaN(year) ||
      day < 1 || day > 31 ||
      month < 1 || month > 12
    ) return false

    const date = new Date(year, month - 1, day)

    if (
      date.getDate() !== day ||
      date.getMonth() !== month - 1 ||
      date.getFullYear() !== year
    ) return false

    const today = new Date()
    let calculatedAge = today.getFullYear() - date.getFullYear()
    const monthDiff = today.getMonth() - date.getMonth()

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
      calculatedAge--
    }

    return calculatedAge >= 18 && calculatedAge <= 120
  }),
  cpf: yup
    .string()
    .required(messageHelper.yup.creator.error.documentIsMandatory)
    .test('document validation', 'CPF é inválido.', (value) => {
      if (value) {
        return cpfValidator(value)
      } else return false
    }),
  phone: yup
    .string()
    .required('Telefone é obrigatório.')
    .test('valid-phone', 'Telefone inválido.', (value) => {
      if (!value) return false
      return phoneValidate(value)
    }),

  password: yup.string().required('Senha é obrigatória'),
  confirmPassword: yup
    .string()
    .required(messageHelper.yup.creator.error.confirmPasswordText)
    .matches(
      /^(?=.*[a-z])(?=.*[0-9])(?=.{8,})/,
      messageHelper.yup.creator.error.rulePassowrdIncorrectText
    )
    .when('password', {
      is: (password: string | undefined) => !!(password && password.length > 0),
      then: yup
        .string()
        .oneOf(
          [yup.ref('password')],
          messageHelper.yup.creator.error.ruleMatchPasswordIncorrectText
        )
    })
})
